import React,  { useState } from 'react';
import {InputGroup, Form, Button} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

// Belépés/regisztráció e-mail-címmel: a megadott címre belépő linket küldünk.
// Használati szempontból a két eset ugyanaz (aki még nincs a rendszerben, az első belépéssel regisztrál).
export default function EmailBelepes(props) {
  const [form_emailcim_validated, setForm_emailcim_validated] = useState(false);
  const [email_in_form, setEmail_in_form] = useState(undefined);
  const [email_sikeresen_megadva, setEmail_sikeresen_megadva] = useState(false);
  const [kuldes_hibauzenet, setKuldes_hibauzenet] = useState('');
  const [gombLathato, setGombLathato] = useState(true)

  function onSubmit_emailcim_megadasa(event){
    event.preventDefault();
    event.stopPropagation();
    if (props.getCommInProgress()){ return; }
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
        // rossz emailcím
        setForm_emailcim_validated(true);
        return;
    }

    // nem ellenőrizzük, hogy mi van vele, csak küldünk egy emailt, amivel folytathatja
    setGombLathato(false);

    props.callAPI("General.sendLoginLink", {email: email_in_form, rendezvenyID: props.rendezvenyID}, function(resp){
        setEmail_sikeresen_megadva(resp.data.sendResult === 'ok');
        setKuldes_hibauzenet(resp.data.sendResult);
        if (resp.data.sendResult !== 'ok') {
            // pl. a gyakoriság-korlát üzenete: az űrlap újra használható
            setGombLathato(true);
        }
        props.onComplete(resp.data.sendResult === 'ok')
    });
  }

  if (email_sikeresen_megadva) {
    return (
      <div className="emailBelepes">
        <div className="koszonet">
          <div className="ikon"><FontAwesomeIcon icon="fa-envelope-circle-check" size='2x' /></div>
          <b>Köszönjük!</b><br />
          Rendszerünk belépő linket küldött a megadott e-mail-címre.<br />
          <b>Zárja be ezt az ablakot, és az e-mailben kapott gombbal folytassa a regisztrációt.</b>
          {props.onBezar ?
            <div><br /><Button variant="outline-secondary" onClick={props.onBezar}>Bezárás</Button></div>
            : undefined
          }
        </div>
      </div>
    );
  }

  return (
    <div className="emailBelepes">
      {gombLathato ?
        <div>
          <div className="felirat">Lépjen be, vagy regisztráljon e-mail-címével!</div>
          <div className="halk">Küldünk egy belépő linket, jelszóra nincs szükség.</div>

          {kuldes_hibauzenet !== '' && kuldes_hibauzenet !== 'ok' ?
            <div className="hiba">{kuldes_hibauzenet}</div>
            : undefined
          }

          <Form noValidate validated={form_emailcim_validated} onSubmit={onSubmit_emailcim_megadasa} >
              <Form.Group className="mb-3" controlId="formEmailBelepes">
                  <InputGroup hasValidation={true}>
                      <InputGroup.Text><FontAwesomeIcon icon="fa-envelope" /></InputGroup.Text>
                      <Form.Control
                          required
                          type="email"
                          placeholder="E-mail-cím"
                          value={email_in_form || ''}
                          onChange={e => setEmail_in_form(e.target.value)}
                          />
                      <Form.Control.Feedback type="invalid">Adjon meg érvényes e-mail-címet!</Form.Control.Feedback>
                  </InputGroup>
              </Form.Group>
              <Button className="belepesGomb" type="submit">Belépési link kérése</Button>
          </Form>
        </div>
        :
        <div className="kerjuk_varjon">Kérjük, várjon!</div>
      }
    </div>
  )
}
